module.exports = __webpack_public_path__ + "img/illu-ball.034f09fa.svg";